var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.087 13.752a1.72 1.72 0 0 1 0 2.572l-5.833 5.192c-.31.277-.72.445-1.17.445a1.74 1.74 0 0 1-1.75-1.73c0-.511.223-.97.579-1.287l2.444-2.176H1.75A1.74 1.74 0 0 1 0 15.038c0-.956.783-1.73 1.75-1.73h10.607l-2.444-2.176a1.718 1.718 0 0 1-.58-1.286c0-.956.784-1.731 1.75-1.731.45 0 .861.168 1.171.444l5.833 5.193zM28 15.002v13.267A1.74 1.74 0 0 1 26.25 30H17.5a1.74 1.74 0 0 1-1.75-1.73c0-.957.784-1.732 1.75-1.732h7V3.462h-7a1.74 1.74 0 0 1-1.75-1.731C15.75.775 16.534 0 17.5 0h8.75C27.217 0 28 .775 28 1.73v13.272z",
    fill: "#3285C2",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIconActive);
export default __webpack_public_path__ + "static/media/loginIconActive.864cdb65.svg";
export { ForwardRef as ReactComponent };